import axios from 'axios'

export const getGoogleApiKey = async () => await axios.get('ECM/getgoogleapikey');

export const getLocation = async (lat, lng) => await axios.get(`ECM/getlocation/${lat}/${lng}`);

export const getImageGeolocation = async (lat, lng) => await axios.get(`ECM/getimagelocation/${lat}/${lng}`);